import React, {useEffect, useState, useContext} from 'react';
import ApplicationContext from '../components/ApplicationContext';
import {postDataWithFetch, getLocalStorage, setLocalStorage} from '../components/Utils';
import Stories from '../components/Stories';
import DragableList from '../components/DragableList';
import ResetTopStoriesModal from '../components/ResetTopStoriesModal';
import "../assets/css/admin.css";

const AdminPage = ({ setData }) => {
	const data = useContext(ApplicationContext);
	const [linkData, setLinkData] = useState();
	const [modalOpen, setModalOpen] = useState(false);

	useEffect(() => {
		const username = getLocalStorage("username");
		// console.log("DEBUG", `AdminPage:  username = ${username}`);
		if (!username && username !== 'admin') {
			setLocalStorage('currentPage', 'login');
			data.currentPage = 'login';
			setData((prev) => ({ ...prev, currentPage: 'login' }))
		}
	}, [data, data.currentPage, setData]);

	const refreshLinkData = (list) => {
		if (!Array.isArray(list)) {
			return false;
		}

		return list?.map(e => {
			return {
				...e,
				URL_ORIGINAL: e['URL'],
				TITLE_ORIGINAL: e['TITLE'],
				ENABLED_ORIGINAL: e['ENABLED']				
			};
		});
	};

	useEffect(() => {
		if (data.linkData) {
			// data.linkData.forEach((e,i,arr) => {
			// 	console.log('DEBUG', e.TITLE, e.ENABLED);
			// });
			setLinkData(refreshLinkData(data.linkData));
		}
	}, [data.linkData]);

	const [showLinks, setShowLinks] = useState(false);
	const toggleShowLinks = () => {
		setShowLinks(!showLinks);
	};

	const [showTopStories, setShowTopStories] = useState(false);
	const toggleTopStories = () => {
		setShowTopStories(!showTopStories);
	};

	const [showArrangeCategories, setShowArrangeCategories] = useState(false);
	const toggleShowArrangeCategories = () => {
		setShowArrangeCategories(!showArrangeCategories);
	};

	const entryParser = (entry) => {
		if (Array.isArray(entry) && entry.length === 3 && entry[1].foregroundColor && entry[1].backgroundColor) {
			return {
				title:entry[0],
				foregroundColor:entry[1].foregroundColor,
				backgroundColor:entry[1].backgroundColor,
				enabled:entry[1].enabled,
				new:entry[1].new
			};
		}
		else {
			return false;
		}
	};

	const [clickedSave, setClickedSave] = useState(false);
	const [statusText, setStatusText] = useState("");

	useEffect(() => {
		if (clickedSave && data.BASE_URL) {
			(async() => {
				const url = `${data.BASE_URL}index.php/link_data/update_link_data`;
				const parms = {NEW_LINK_DATA: JSON.stringify(linkData)};
				// console.log('DEBUG:  Admin - linkData = ', linkData);
				// console.log('DEBUG:  Admin - ', url);
				// console.log('DEBUG:  Admin - ', parms);
				const json = await postDataWithFetch(url, parms);
				setStatusText(`Saved ${json} records.`);

				if (parseInt(json) > 0) {
					let newList = linkData?.map(e => {
						return {
							...e, 
							URL_ORIGINAL: e['URL'], 
							TITLE_ORIGINAL: e['TITLE'],
							ENABLED_ORIGINAL: e['ENABLED']
						}
					});
					data.linkData = newList;
					// console.log('DEBUG', `Records changed:  ${json}`, newList[0]);
					setLinkData(newList);
				}

				// console.log('DEBUG:  output of update_link_data - ', typeof json, json);
				setClickedSave(false);
			})();
		}
	}, [data, data.BASE_URL, clickedSave, data.linkData, linkData]);

	const saveNewList = () => {
		setClickedSave(true);
	};

	const logout = (e) => {
		e.preventDefault();
		localStorage.removeItem('token');
		localStorage.removeItem('username');
		localStorage.removeItem('is_premium');
		localStorage.removeItem('currentPage');

		// This one is no longer need but clean it up if any user already 
		// has it.  At some point we will just delete this.
		localStorage.removeItem("ADMINUSER");

		setData((prev) => ({ ...prev, currentPage: 'login' }))
		setLocalStorage('currentPage', 'login');
		data.currentPage = 'login';
	};

	return (
		<>
			<h3 className="admin-user-container">
				<label className="all-links" onClick={logout}>Admin Logout</label>
			</h3>

			<h3 className="admin-title-tag all-links" onClick={toggleShowLinks}>Organize special report links (tap to expand/collapse)</h3>
			<div style={{display: showLinks ? 'block' : 'none'}}>
				{linkData?.map((e,i,arr) => (
					<div key={i} className="form-row">
						<div className="form-group">
							<input type="text" value={e.TITLE} onChange={(e) => {
								// console.log('debug', 'entering on change title');
								let tmplinkData = [...linkData];
								tmplinkData[i].TITLE = e.target.value;
								setLinkData(tmplinkData);
								// console.log('debug', 'on change title', e.target.value);
							}} placeholder="Title" />
							<div className="button-container">
								{/* {(() => {
									console.log("DEBUG", `arr[i].ENABLED = ${arr[i].ENABLED}`);
								})()} */}
								<input id={i} className="delete-button" type="checkbox" checked={e.ENABLED === "1" ? true : false} 
									onChange={(e) => {
										let tempList = [...linkData];
										// console.log('DEBUG:  old value = ', tempList[event.target.id].enabled)
										tempList[e.target.id].ENABLED = 
											tempList[e.target.id].ENABLED === "1" ? "0" : "1";
										// console.log('DEBUG:  new value = ', tempList[event.target.id].enabled)
										setLinkData(tempList);
									}}
								/>
								<label htmlFor={i} >ENABLED</label>
							</div>
						</div>
						<div className="form-group">
							<input type="text" value={e.URL} onChange={(e) => {
								// console.log('debug', 'entering on change url');
								let tmplinkData = [...linkData];
								tmplinkData[i].URL = e.target.value;
								setLinkData(tmplinkData);
								// console.log('debug', 'on change url', e.target.value);
							}} placeholder="URL" />
						</div>
					</div>
				))}
				<div className="btn-container">
					<input type="button" value="ADD" onClick={() => {
						if (linkData) {
							let tmplinkData = [...linkData];
							tmplinkData.push({URL:"", TITLE:"", ENABLED: "1"});
							setLinkData(tmplinkData);
						}
						else {
							let tmplinkData = [];
							tmplinkData.push({URL:"", TITLE:"", ENABLED: "1"});
							setLinkData(tmplinkData);
						}
					}} />
				</div>
				<div className="btn-container">
					<input type="button" value="SAVE" onClick={saveNewList} />
				</div>
				<div className="drabable-status-text" style={{display: statusText?.length ? 'block' : 'none'}}>
					<p className="paragraph-status-text">{statusText}</p>
				</div>
			</div>

			<h3 className="admin-title-tag all-links" onClick={toggleTopStories}>Set Top Stories/Tickers (tap to expand/collapse)</h3>
			<div style={{display: showTopStories ? 'block' : 'none'}}>
				<Stories enableAdmin={true} />
			</div>

			<h3 className="admin-title-tag all-links" onClick={() => {
					setModalOpen(true);
				}}>Reset Top Stories
			</h3>
			{modalOpen && <ResetTopStoriesModal setOpenModal={setModalOpen} />}

			{data.choicePairsList && <><h3 className="admin-title-tag all-links" onClick={toggleShowArrangeCategories}>Organize categories (tap to expand/collapse)</h3>
			<div style={{display: showArrangeCategories ? 'block' : 'none'}}>
				<p className="admin-messsage">
					You will need to do this on a desktop computer, drag and drop on 
					mobile doesn't work right when you attempt to combine this with 
					scrolling.  I have a mobile solution for this but it isn't quite right 
					yet.  Still working on it.
				</p>
				<DragableList list={data.choicePairsList} entryParser={entryParser} />
			</div></>}
		</>
	);
};

export default AdminPage;
